import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { FontWeights } from '@customTypes/theme';

export type TextVariantProps =
  | {
      variant: 'h1';
      fontWeight?: keyof Omit<FontWeights, 'fontWeightBold'>;
    }
  | {
      variant: 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body';
      fontWeight?: keyof Omit<FontWeights, 'fontWeightExtraBold'>;
    }
  | {
      variant: 'bodyBig' | 'bodySmall';
      fontWeight?: keyof Pick<
        FontWeights,
        'fontWeightRegular' | 'fontWeightMedium' | 'fontWeightSemiBold'
      >;
    };

export type TextProps = TextVariantProps &
  Omit<TypographyProps, 'fontWeight'> & { component?: React.ElementType };

const Text: React.FC<TextProps> = (props) => {
  return <Typography {...props}>{props.children}</Typography>;
};

export default Text;
